<template>
  <thead>
    <transition-group name="fade" tag="tr" v-for="(cols,idx) in multiRows" :key="idx">
      <th class="th" v-if="shouldRenderSelection" key="--th-multi">
        <multi-select :selection="selection" :rows="data" />
      </th>
      <th class="th" v-for="(col, idx) in cols"
        :key="idx || col.field || col.title"
        :class="col.thClass" :style="col.thStyle" :colspan="col.thSpan">
        <!-- <th> component (thComp) -->
        <component
          v-if="col.thComp"
          :is="forDynCompIs(col.thComp)"
          :column="col"
          :field="col.nested||col.field"
          :title="col.title"
          :sub_title="col.sub_title"
          v-bind="$props">
        </component>
        <template v-else>
          {{ col.title }}
        </template>

        <i v-if="col.explain" class="fa fa-info-circle" style="cursor: help" :title="col.explain"></i>
        <head-sort v-if="col.sortable" :field="col.nested||col.field" :query="query" />
      </th>
    </transition-group>
  </thead>
</template>
<script>
import HeadSort from './HeadSort.vue'
import MultiSelect from './MultiSelect.vue'
import props from '../_mixins/props'
import shouldRenderSelection from '../_mixins/shouldRenderSelection'

export default {
  name: 'TableHeader',
  components: { HeadSort, MultiSelect },
  mixins: [props, shouldRenderSelection],
  data(){
    return {
      multiRows: []
    }
  },
  created(){
    if (this.multiHeaders) {
      this.multiRows = this.columns;
    }else{
      this.multiRows[0] = this.columns;
    }
  },
}
</script>
<style>
table thead .th{
  padding: 1.20rem !important;
  /*text-align: center;*/
  position: sticky;
  top: 0px;
  background-color: #eee !important;
  color: #000;
  z-index: 99;
}
.th.leftfixed{
  position: sticky;
  left: 0;
  z-index: 1006 !important;
}
.eachThree .th:nth-of-type(3n-2) {    
    border-right: 3px solid #c2cad1 !important;
}
</style>
